import { render } from "./radio.vue?vue&type=template&id=06b73efe&lang=pug"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/radio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06b73efe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06b73efe', __exports__)) {
    api.reload('06b73efe', __exports__)
  }
  
  module.hot.accept("./radio.vue?vue&type=template&id=06b73efe&lang=pug", () => {
    api.rerender('06b73efe', render)
  })

}


export default __exports__